export type QRCodeParams = {
  projectId?: string;
  qrCodeUUID?: string;
  siteUUID?: string;
  encryptedSiteId?: string;
  encryptedPatientSourceUUID?: string;
  instanceUrl?: string;
};

export type ExtendedQRCodeParams = {
  type: QRTypes;
  isClassicOnboarding?: boolean;
  isDeepLink?: boolean;
} & QRCodeParams;

export enum QRDataExtractionStatus {
  Pending,
  Success,
  Error,
}

export enum QRTypes {
  Classic = 'classic',
  Invitation = 'invitation',
}
